import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro'
import React from 'react'
import './ConfirmModal.scss'

export default function GenericConfirmModal({
  onClose,
  onCancelButton,
  onConfirm,
  title = 'Are you sure?',
  content = 'Are you sure?',
  cancelTxt = 'Cancel',
  confirmTxt = 'Confirm',
  showCancel = true,
}) {
  return (
    <CModal
      className="confirm-modal"
      visible={true}
      onClose={onClose}
      fullscreen="md"
      alignment={'center'}
    >
      <CModalHeader className="d-flex">{title}</CModalHeader>
      <CModalBody>
        <div style={{ textAlign: 'center' }}>{content}</div>
      </CModalBody>
      <CModalFooter>
        {showCancel && (
          <CButton color="secondary" onClick={onCancelButton || onClose}>
            {cancelTxt}
          </CButton>
        )}
        <CButton color="primary" onClick={onConfirm}>
          {confirmTxt}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
